import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ContactForm from './ContactForm'
import WavyBackground from '../../../components/WavyBackground'
import WidthContainer from '../../../components/WidthContainer'
import Markdown from '../../../components/Markdown'

const phoneBreakpoint1 = '@media only screen and (max-width: 800px)'
const phoneBreakpoint2 = '@media only screen and (max-width: 500px)'

const RootContainer = styled(WavyBackground)`
`
RootContainer.defaultProps = {
	type: 'grayTop',
}

const InnerContainer = styled(WidthContainer)`
	display: flex;
	width: 100%;
	padding-bottom: 2rem;
	align-items: center;
	
	${phoneBreakpoint1} {
		flex-direction: column;
	}
`

const FormColumn = styled.div`
	max-width: 24rem;
	width: 100%;
`

const ColumnsColumn = styled.div`
	flex: 1;
	display: flex;
	margin: -1rem -2rem -3rem 0rem;
	justify-content: flex-end;
	
	> * {
		margin: 0rem 3rem;
	}
	
	${phoneBreakpoint1} {
		margin-top: 2rem;
	}
	
	${phoneBreakpoint2} {
		flex-direction: column;
	}
`

const OneColumnsColumn = styled.div`
`

const ColumnTitle = styled.div`
	color: ${props => props.theme.colors.main};
	font-weight: ${props => props.theme.fontWeights.bold};
	font-size: ${props => props.theme.fontSizes.small};
	text-transform: uppercase;
	margin-bottom: 1.25rem;
`

const ColumnText = styled(Markdown)``


const FormSection = ({className, data}) => <RootContainer className={className}>
	<InnerContainer>
		<FormColumn>
			<ContactForm data={data.form}/>
		</FormColumn>
		<ColumnsColumn>
			<OneColumnsColumn>
				<ColumnTitle>{data.columns.column1.title}</ColumnTitle>
				<ColumnText text={data.columns.column1.contentMd}/>
			</OneColumnsColumn>
			<OneColumnsColumn>
				<ColumnTitle>{data.columns.column2.title}</ColumnTitle>
				<ColumnText text={data.columns.column2.contentMd}/>
			</OneColumnsColumn>
		</ColumnsColumn>
	</InnerContainer>
</RootContainer>

FormSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		form: ContactForm.propTypes.data,
		columns: PropTypes.shape({
			column1: PropTypes.shape({
				title: PropTypes.string,
				contentMd: PropTypes.string,
			}).isRequired,
			column2: PropTypes.shape({
				title: PropTypes.string,
				contentMd: PropTypes.string,
			}).isRequired,
		}).isRequired,
	}).isRequired,
}

FormSection.defaultProps = {
	className: '',
}

export default FormSection
